export const preselectFiltersPassedInUrl = () => {
    const filterLists = [...document.querySelector('.cards__filters')?.querySelectorAll('.form-select__list')];
    let filtersFromUrl = decodeURI(window.location.search.split("?filters=")[1]);

    filterLists.forEach(ul => {
        [...ul.children]?.forEach(li => {
            const checkbox = li.querySelector('input');

            if (filtersFromUrl.includes(checkbox?.value)) {
                checkbox.checked = true;
            }
        });
    });
}